/** Join a Vite public asset to the build base path (for example `/storefront/`). */
export function joinPublicAssetUrl(basePath: string, assetPath: string): string {
  const base = `/${basePath.replace(/^\/+|\/+$/g, '')}/`.replace(/^\/\/$/, '/');
  return `${base}${assetPath.replace(/^\/+/, '')}`;
}

export function publicAssetUrl(assetPath: string): string {
  return joinPublicAssetUrl(import.meta.env.BASE_URL || '/', assetPath);
}
